import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import { Provider } from "rebass";
import { injectGlobal } from 'styled-components'

injectGlobal`
  * { box-sizing: border-box; }
  body { margin: 1em; }
`
const TemplateWrapper = ({ children }) => (
    <Provider>
        <Helmet title="Symfony 4 Workshop" />
        <div>{children()}</div>
    </Provider>
);

TemplateWrapper.propTypes = {
    children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js